import React from 'react';

import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';
import { useExit } from 'src/hooks/useExit';

export function ReservedSlotExpired() {
    const exit = useExit();

    return (
        <>
            <ContentContainer className="flex-1 space-y-6 text-center lg:flex-none">
                <FeaturedIcon size="lg" color="error" className="mx-auto mb-8" />
                <h1 className="text-2xl font-medium text-gray-900">Session expired</h1>
                <p>
                    Your booking session has ended due to inactivity.
                    <br />
                    Please exit and restart your booking.
                </p>
            </ContentContainer>
            <StickyBottomBar>
                <Button className="w-full" color="gray" onClick={() => exit()}>
                    Exit
                </Button>
            </StickyBottomBar>
        </>
    );
}
